// @generated by protoc-gen-es v1.7.2
// @generated from file ibc/core/commitment/v2/commitment.proto (package ibc.core.commitment.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * MerklePath is the path used to verify commitment proofs, which can be an
 * arbitrary structured object (defined by a commitment type).
 * MerklePath is represented from root-to-leaf
 *
 * @generated from message ibc.core.commitment.v2.MerklePath
 */
export const MerklePath = proto3.makeMessageType(
  "ibc.core.commitment.v2.MerklePath",
  () => [
    { no: 1, name: "key_path", kind: "scalar", T: 12 /* ScalarType.BYTES */, repeated: true },
  ],
);

